import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { QuoteDto } from './getFileQuotesQuery';

const ENDPOINT = `${APIConfiguration.repairer}quotes`;

export interface GetQuoteByIdQueryArgs {
  quoteId: string;
}

export const getQuoteByIdRequest = (
  payload: GetQuoteByIdQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.quoteId}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getQuoteByIdQuery = async (
  payload: GetQuoteByIdQueryArgs,
): Promise<BackResponse<QuoteDto> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<QuoteDto>>(
      getQuoteByIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
